<script lang="ts" setup>
/**
 * トークルーム総数。
 */

import { defineProps, nextTick } from "vue";
import { LayoutTagGetResponse_WordSetting } from "@/apiRequests/models/communityTalk/layoutTagGetResponse";

interface Props {
	/**
	 * トークルーム総数。
	 */
	talkRoomCount: number;
	/**
	 * リプライ付きトークルーム総数。
	 */
	talkRoomCountWithReply: number;
	/**
	 * 表示タグ設定>文言設定。
	 */
	wordSettings: LayoutTagGetResponse_WordSetting;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();

nextTick(() => {
	// ReviCoタグマネージャー等で外部定義された関数が存在すれば発火
	// なぜ?: data属性で定義したトークルーム件数、リプライ件数を外部定義の関数から取得できるようにするため
	// eslint-disable-next-line no-undef
	if (typeof revico_communitytalk_talkroomcount_complete === "function") {
		// eslint-disable-next-line no-undef
		revico_communitytalk_talkroomcount_complete();
	}
});
</script>

<template>
	<section class="revico-community-talk-talkroom-count" :data-revico-community-talk-talkroom-count="talkRoomCount" :data-revico-community-talk-talkroom-count-with-reply="talkRoomCountWithReply">
		<p class="revico-community-talk-talkroom-count--all">全{{ talkRoomCount }}{{ wordSettings.postCountUnit }}</p>
		<p class="revico-community-talk-talkroom-count--with-reply">{{ wordSettings.talkRoomWithReplyText }}:{{ talkRoomCountWithReply }}{{ wordSettings.postCountUnit }}</p>
	</section>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	&-talkroom-count {
		display: flex;
		justify-content: flex-end;
		width: 100%;
		margin-bottom: 8px;

		&--all {
			&::after {
				content: "-";
				margin: 0 8px;
			}
		}

		&--with-reply {
			padding-top: 2px;
			font-size: 0.8em;
		}
	}
}
</style>
